import { AfterViewInit, Component, NgZone, OnInit } from '@angular/core';
import { EditableMetadataInterface } from 'app/models/editable-metadata-interface';
import { FileClass } from 'app/models/file-class';
import { ContactService } from 'app/services/contactService';
import { DataService } from 'app/services/data.service';
import { FileClassService } from 'app/services/file-class.service';
import { TeamService } from 'app/services/team.service';
import { UserService } from 'app/services/user.service';
import { Form } from '@atefhashem/eforms';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-metadata-editor-modal',
  templateUrl: './metadata-editor-modal.component.html',
  styleUrls: ['./metadata-editor-modal.component.scss']
})
export class MetadataEditorModalComponent implements OnInit, AfterViewInit {

  uniqueID: string = '';

  filesToEdit: EditableMetadataInterface[] = [];
  fileClasses: FileClass[] = [];
  currentFileClass: FileClass = null;
  currentMetadataForm: Form = null;
  isMetadataValid: boolean = true;

  savedMetadataSubject: Subject<any> = new Subject;
  cancelMetadataSubject: Subject<any> = new Subject;

  constructor(public modalRef: MDBModalRef, private ngZone: NgZone, private fileClassService: FileClassService,
    private dataService: DataService, private userService: UserService, private teamService: TeamService, private contactService: ContactService) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.currentFileClass = this.fileClasses[0];  // select None as default
    if (this.filesToEdit.length == 1) {
      this.currentFileClass = this.fileClasses.find((fileClass) => { return fileClass.name == (this.filesToEdit[0].fileClass || ''); } );
      this.fileClassChanged(this.currentFileClass);
    }    
  }
  cleanUpMetadataForm() {
    this.currentFileClass=this.fileClasses[0];  // none
    document.getElementById('metadata_form_' + this.uniqueID).innerHTML = '';
  }

  saveMetadata() {
    this.filesToEdit.forEach((file) => {
      file.fileClass = this.currentFileClass.name;
      file.metadata = this.currentMetadataForm.instance.submission.data;
    });
  }

  fileClassChanged(selectedFileClass: FileClass) {
    document.getElementById('metadata_form_' + this.uniqueID).innerHTML = "";
    this.isMetadataValid = true;  // default is valid
    this.currentMetadataForm = new Form(document.getElementById('metadata_form_' + this.uniqueID), 
                                        this.fileClassService.formFromFileClass(selectedFileClass), 
                                        {
                                          noAlerts: true,
                                          evalContext: {
                                            getDataFieldTermsObservable: (indexPattern: string, fieldKey: string, searchFilter: string = '') =>  {
                                              return this.dataService.getFieldTerms(indexPattern, fieldKey, searchFilter);
                                            },
                                            getDataRawSearchObservable: (indexPattern: string, body: any) => {
                                              return this.dataService.rawSearch(indexPattern, body);
                                            },
                                            getDataSQLQueryObservable: (query: string, format: string = 'json') => {
                                              return this.dataService.sqlQueryResults(query, format);
                                            },
                                            /** @note these do not work in external access yet */
                                            getUsersObservable: () => {
                                              return this.userService.getAll();
                                            },
                                            getTeamsObservable: () => {
                                              return this.teamService.getAll();
                                            },
                                            getContactsObservable: () => {
                                              return this.contactService.getAll();
                                            }
                                          }
                                        });
    this.currentMetadataForm.ready.then((form) => {
      if (this.filesToEdit.length == 1 && selectedFileClass.name == this.filesToEdit[0].fileClass) {
        form.submission = { data: this.filesToEdit[0].metadata };
      }
    });
    this.currentMetadataForm.instance.on('change', (event) => {
      this.ngZone.run(() => {
        this.isMetadataValid = event.isValid;
      });
    });
    this.currentMetadataForm.render();
  }
}
